import { getMonth, getDate } from 'date-fns';

interface ThemePeriod {
    start: { month: number; day: number }; // inclusive
    end: { month: number; day: number }; // inclusive
    suffix: string;
}

// Full Year Coverage - Granular (4-10 days max)
const THEMES: ThemePeriod[] = [
    // --- JANVIER ---
    { start: { month: 0, day: 1 }, end: { month: 0, day: 4 }, suffix: "de la Bonne Année" },
    { start: { month: 0, day: 5 }, end: { month: 0, day: 10 }, suffix: "de la Galette des Rois" },
    { start: { month: 0, day: 11 }, end: { month: 0, day: 18 }, suffix: "des Bonnes Résolutions" },
    { start: { month: 0, day: 19 }, end: { month: 0, day: 25 }, suffix: "de la Detox (ratée)" },
    { start: { month: 0, day: 26 }, end: { month: 0, day: 31 }, suffix: "de la Raclette" },

    // --- FEVRIER ---
    { start: { month: 1, day: 1 }, end: { month: 1, day: 4 }, suffix: "des Crêpes" }, // Chandeleur (2)
    { start: { month: 1, day: 5 }, end: { month: 1, day: 10 }, suffix: "de l'Hiver" },
    { start: { month: 1, day: 11 }, end: { month: 1, day: 15 }, suffix: "des Amoureux" }, // St Val (14)
    { start: { month: 1, day: 16 }, end: { month: 1, day: 22 }, suffix: "du Tout Schuss" },
    { start: { month: 1, day: 23 }, end: { month: 1, day: 29 }, suffix: "de la Fondue" },

    // --- MARS ---
    { start: { month: 2, day: 1 }, end: { month: 2, day: 8 }, suffix: "du Café Grand-Mère" },
    { start: { month: 2, day: 9 }, end: { month: 2, day: 15 }, suffix: "des Giboulées" },
    { start: { month: 2, day: 16 }, end: { month: 2, day: 19 }, suffix: "de la Saint-Patrick" }, // 17
    { start: { month: 2, day: 20 }, end: { month: 2, day: 25 }, suffix: "du Réveil de la Force" },
    { start: { month: 2, day: 26 }, end: { month: 2, day: 31 }, suffix: "du Sidaction" },

    // --- AVRIL ---
    { start: { month: 3, day: 1 }, end: { month: 3, day: 4 }, suffix: "du Poisson d'Avril" }, // 1
    { start: { month: 3, day: 5 }, end: { month: 3, day: 12 }, suffix: "de la Chasse aux Œufs" },
    { start: { month: 3, day: 13 }, end: { month: 3, day: 20 }, suffix: "du Chocolat" },
    { start: { month: 3, day: 21 }, end: { month: 3, day: 30 }, suffix: "du Premier Barbecue" },

    // --- MAI ---
    { start: { month: 4, day: 1 }, end: { month: 4, day: 4 }, suffix: "du Muguet" }, // 1
    { start: { month: 4, day: 5 }, end: { month: 4, day: 9 }, suffix: "de la Force" }, // 4
    { start: { month: 4, day: 10 }, end: { month: 4, day: 19 }, suffix: "des Ponts de Mai" },
    { start: { month: 4, day: 20 }, end: { month: 4, day: 25 }, suffix: "des Saints de Glace" },
    { start: { month: 4, day: 26 }, end: { month: 4, day: 31 }, suffix: "du Grand Prix" },

    // --- JUIN ---
    { start: { month: 5, day: 1 }, end: { month: 5, day: 9 }, suffix: "de la Terre Battue" },
    { start: { month: 5, day: 10 }, end: { month: 5, day: 17 }, suffix: "des Examens" },
    { start: { month: 5, day: 18 }, end: { month: 5, day: 23 }, suffix: "de la Musique" }, // 21
    { start: { month: 5, day: 24 }, end: { month: 5, day: 30 }, suffix: "de la Chipolata" },

    // --- JUILLET ---
    { start: { month: 6, day: 1 }, end: { month: 6, day: 10 }, suffix: "du Grand Départ" },
    { start: { month: 6, day: 11 }, end: { month: 6, day: 16 }, suffix: "du Feu d'Artifice" }, // 14
    { start: { month: 6, day: 17 }, end: { month: 6, day: 24 }, suffix: "du Maillot Jaune" },
    { start: { month: 6, day: 25 }, end: { month: 6, day: 31 }, suffix: "de la Soif" },

    // --- AOUT ---
    { start: { month: 7, day: 1 }, end: { month: 7, day: 10 }, suffix: "du Rosé Piscine" },
    { start: { month: 7, day: 11 }, end: { month: 7, day: 18 }, suffix: "du Farniente" },
    { start: { month: 7, day: 19 }, end: { month: 7, day: 25 }, suffix: "des Embouteillages" },
    { start: { month: 7, day: 26 }, end: { month: 7, day: 31 }, suffix: "de la Biafine" },

    // --- SEPTEMBRE ---
    { start: { month: 8, day: 1 }, end: { month: 8, day: 7 }, suffix: "de la Rentrée" },
    { start: { month: 8, day: 8 }, end: { month: 8, day: 15 }, suffix: "de la Reprise du Sport" },
    { start: { month: 8, day: 16 }, end: { month: 8, day: 22 }, suffix: "des Vieilles Pierres" },
    { start: { month: 8, day: 23 }, end: { month: 8, day: 30 }, suffix: "de l'Été Indien" },

    // --- OCTOBRE ---
    { start: { month: 9, day: 1 }, end: { month: 9, day: 8 }, suffix: "d'Octobre Rose" },
    { start: { month: 9, day: 9 }, end: { month: 9, day: 16 }, suffix: "du Ruban Rose" }, // Variant
    { start: { month: 9, day: 17 }, end: { month: 9, day: 24 }, suffix: "du Brame du Cerf" },
    { start: { month: 9, day: 25 }, end: { month: 9, day: 31 }, suffix: "d'Halloween" }, // 31

    // --- NOVEMBRE ---
    { start: { month: 10, day: 1 }, end: { month: 10, day: 5 }, suffix: "de la Toussaint" }, // 1
    { start: { month: 10, day: 6 }, end: { month: 10, day: 10 }, suffix: "de la Gadoue" },
    { start: { month: 10, day: 11 }, end: { month: 10, day: 15 }, suffix: "de l'Armistice" }, // 11
    { start: { month: 10, day: 16 }, end: { month: 10, day: 22 }, suffix: "du Beaujolais Nouveau" },
    { start: { month: 10, day: 23 }, end: { month: 10, day: 30 }, suffix: "des Promotions" }, // Black Friday

    // --- DECEMBRE ---
    { start: { month: 11, day: 1 }, end: { month: 11, day: 6 }, suffix: "du Téléthon" },
    { start: { month: 11, day: 7 }, end: { month: 11, day: 13 }, suffix: "de la Saint-Nicolas" },
    { start: { month: 11, day: 14 }, end: { month: 11, day: 20 }, suffix: "de la Course aux Cadeaux" },
    { start: { month: 11, day: 21 }, end: { month: 11, day: 26 }, suffix: "de Noël" }, // 25
    { start: { month: 11, day: 27 }, end: { month: 11, day: 31 }, suffix: "de la Saint-Sylvestre" }
];

export const getThemeSuffix = (date: Date): string => {
    const month = getMonth(date);
    const day = getDate(date);

    const theme = THEMES.find(t => {
        return month === t.start.month && day >= t.start.day && day <= t.end.day;
    });

    if (theme) return theme.suffix;
    return "du Jour"; // Should not happen with 100% coverage
};
